import { z } from 'zod';

export const ProdutoUnidadeSchema = z.object({
    pru_descricao: z.string(),
    pru_idpk: z.number(),
    pru_sigla: z.string().nullable(),
    pru_ultima_alteracao: z.string().nullable(),
});

export type ProdutoUnidade = z.infer<typeof ProdutoUnidadeSchema>;
